/** 全局状态管理 */
import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, getFromLocal } from '../js/tool'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // token: "",
    user_name: getFromLocal("user_name"),  // 用户名
    user_pic: getFromLocal("user_pic") ? getFromLocal("user_pic") : null,   // 头像
    my_pic: getFromLocal("my_pic") ? getFromLocal("my_pic") : null,   // 头像
    server_name: getFromLocal("server_name"),
    server_phone: getFromLocal("server_phone"),
    server_mobilephone: getFromLocal("server_mobilephone"),
    server_email: getFromLocal("server_email"),
    tenant_id: getFromLocal("tenant_id"),  // 企业ID
    tenant_name: getFromLocal("tenant_name"),  // 企业名称
    unreadNum: 0,
    // customer_id: "", // 所属客户id
    isLogin: getToken(), // 登陆状态
    route: {},  // 当前路由信息，用于刷新导航栏样式
    // 要缓存的页面， 缓存列表页，需要缓存页面必须声明export default中的name，其值必须包含在此数组中
    cachedPages: [
      "EmployeeInfo",
      "EmployeeContract",
      "SocialSecurity",
      "SalaryBatches",
      "SalaryDetails",
      "Message",
      // "Redirect" // (前置：暂不需使用)中转页也缓存，同时设置缓存页面数量为1，所以列表页也能通过中转页重载
    ],
    // goBackBtn: false,  // 头部返回按钮
    clientWidth: document.body.clientWidth,
  },
  mutations: {
    // 登录
    login(state, data) {
      state.user_name = data.user_name;
      localStorage.setItem("user_name", data.user_name);
      state.isLogin = true;
      state.server_name = data.server_name;
      state.server_phone = data.server_phone;
      state.server_mobilephone = data.server_mobilephone;
      state.server_email = data.server_email;
      state.tenant_id = data.tenant_id;
      state.tenant_name = data.tenant_name;
    },
    // 退出登录
    logout(state) {
      state.isLogin = false;
      state.user_name = "";
      state.user_pic = null;
      state.my_pic = null;
      state.cachedPages = [];
    },
    //更换我的头像
    my_pic(state, data) {
      localStorage.setItem("my_pic", data);
      state.my_pic = data;
    },
    // 更换头像
    user_pic(state, data) {
      localStorage.setItem("user_pic", data);
      state.user_pic = data;
    },
    // 更新企业名称
    tenant_name(state, data) {
      localStorage.setItem("tenant_name", data);
      state.tenant_name = data;
    },
    // 路由变更
    routeChange(state, data) {
      state.route = data.route
    },
    // 缓存页面变更
    cacheToggle(state, bool) {
      if (bool) {
        state.cachedPages = [
          "EmployeeInfo",
          "EmployeeContract",
          "SocialSecurity",
          "SalaryBatches",
          "SalaryDetails"
        ];
      } else {
        state.cachedPages = [];
      }
    },
    unreadMessage(state, num) {
      state.unreadNum = num;
    },
    clientWidth(state, num) {
      state.clientWidth = num
    }
  },
  actions: {
  },
  modules: {
  }
})
